var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

(function ($) {
    MDB.Charts.renderers.iconWithText = function (widget, chart, data, metadata) {
        var config = metadata.KendoConfig;

        if (!config.isCustom && data[0]) {
            var aliasses = MDB.Charts.getColumnAliasses(widget);

            var key = Object.keys(data[0])[0];
            var text = data[0][key];

            config.header.text = aliasses[key];
            config.body.text = text;
        }

        var iconContainer = $('<div />',
            {
                'class': 'icon-widget-container icon-container'
            }
        ).html(sprintf('<i class="%s text-center icon-widget-icon"></i>', config.icon));

        var textContainer = $('<div />',
            {
                'class': 'icon-widget-container text-container'
            }
        )
            .append(createTextContainer(config.header))
            .append(createTextContainer(config.body))

        var mainContainer = $('<div />',
            {
                'class': 'icon-widget-container main-container'
            }
        )
            .append(iconContainer)
            .append(textContainer);

        var iconContainerStyleOpts = {};

        if (config.iconRightMargin) {
            iconContainerStyleOpts['margin-right'] = config.iconRightMargin;
        }

        if (config.iconFontSize) {
            iconContainerStyleOpts['font-size'] = config.iconFontSize;
        }

        iconContainer.css(iconContainerStyleOpts);

        chart.siblings('.loading-box').remove();

        chart.append(mainContainer);

        widget.trigger('resize');
    }

    function createTextContainer(opts) {
        var containerStyleOpts = {};

        if (opts.font) {
            var fontOpts = opts.font.split(' ');

            if (fontOpts.length >= 1) {
                containerStyleOpts['font-family'] = fontOpts[1];
            }

            containerStyleOpts['font-size'] = fontOpts[0];
        }

        if (opts.background) {
            containerStyleOpts['background-color'] = opts.background;
        }

        if (opts.color) {
            containerStyleOpts['color'] = opts.color;
        }

        var container = $('<span />');
        container.text(opts.text);
        container.css(containerStyleOpts);

        return $('<div />').append(container);
    }
})(jQuery);